<p-confirmDialog key="login1" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>
<p-confirmDialog key="login2" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>
<p-confirmDialog key="login3" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>
<p-confirmDialog key="login4" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!-- <div class="middle-box text-center loginscreen animated fadeInDown"> -->
<div class="CustomMiddleBox text-center loginscreen animated fadeInDown MainDiv">
	<!--Logo and Info-->
	<div>
		<caass-login-logo
			[DistrictInfoLoading]="DistrictInfoLoading"
			[ShowDistrictName]="ShowDistrictName"
			[DistrictDisplayName]="DistrictDisplayName"
			[DistrictVersionNumber]="DistrictVersionNumber"
			[VersionChecked]="VersionChecked"
			[VersionMatch]="VersionMatch"
			[CAASS_VERSION]="CAASS_VERSION"
			[errorMessage]="errorMessage"
		></caass-login-logo>
	</div>

	<div *ngIf="VersionMatch == true">
		<!--Username + Password-->
		<div *ngIf="LoginStep == 1">
			<p>Please type your Username & Password to Login.</p>

			<div class="Grid1Col">
				<input [disabled]="IsLoading() == true" class="form-control MaxButtonWidth" type="text" placeholder="Username" [(ngModel)]="Username" />
				<form>
					<input
						name="Password"
						[disabled]="IsLoading() == true"
						class="form-control MaxButtonWidth"
						type="password"
						placeholder="Password"
						[(ngModel)]="Password"
					/>
				</form>
				<button id="LoginButton" [disabled]="IsLoading() == true" class="btn btn-primary MaxButtonWidth" (click)="onLoginStep1()">
					Login as Support
				</button>
			</div>

			<div class="SmallTopMargin">
				<button [disabled]="IsLoading() == true" class="LinkButton" (click)="onForgotPassword()">
					<small>Forgot Password?</small>
				</button>
			</div>
		</div>

		<!--MFA Code-->
		<div *ngIf="LoginStep == 2" class="Grid1Col">
			<div *ngIf="ShowQRCode == true">
				<caass-mfa-instructions [QRImage]="QRCodeB64" [ManualCode]="QRManualCode"></caass-mfa-instructions>
			</div>

			<form>
				<input
					name="MFACode"
					[disabled]="IsLoading() == true"
					class="form-control MaxButtonWidth"
					type="password"
					placeholder="MFACode"
					[(ngModel)]="MFACode"
				/>
			</form>
			<button id="LoginMFAButton" [disabled]="IsLoading() == true" class="btn btn-primary MaxButtonWidth" (click)="onLoginStep2()">
				Confirm MFA Code
			</button>

			<div class="SmallTopMargin">
				<button [disabled]="IsLoading() == true" class="LinkButton" (click)="onForgotMFA()">
					<small>Forgot MFA?</small>
				</button>
			</div>
		</div>
	</div>
</div>
